import { BaseRepository } from './BaseRepository';
import handleResponseError from './utils/handleResponseError';

export default class PartnershipRepository extends BaseRepository<any> {
  static getByHost(host: string) {
    return fetch(`${this.apiUrl}/partnership?host=${host}`)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      let res;

      try {
        res = text && JSON.parse(text);
      } catch (e) {
        res = {};
      }

      if (!response.ok) {
        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);
        return Promise.reject(error);
      }

      return res;
    });
  }
}
